package navigation.settings.imagegallery.imageInfos.components

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.file.ui.imageinfos.ImageInfosEvent
import com.essntl.features.file.ui.imageinfos.ImageInfosState
import com.essntl.uikit.components.button.destructive.EsMediumDestructiveButton
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ColumnScope.DeleteNonUsedImage(
    state: ImageInfosState,
    onEvent: (ImageInfosEvent) -> Unit,
) {
    Text(
        text = "No items found for this image, You can delete it now",
        style = MaterialTheme.esTypography.h565018.copy(
            color = MaterialTheme.esColorScheme.textPrimary,
        ),
        modifier = Modifier.padding(
            start = 2.5f.spacing,
            bottom = 2.5f.spacing,
        ),
    )

    EsMediumDestructiveButton(
        onClick = { onEvent(ImageInfosEvent.DeleteImage) },
        text = "Delete Image",
        loading = state.deleteImage.isLoading,
        modifier = Modifier.padding(start = 2.5f.spacing),
    )
}